import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children, redirectTo = '/', allowedRoles = [] }) => {
  const userInfo = useSelector((state) => state.user.userInfo);
  const isAuthLoading = useSelector((state) => state.user.isAuthLoading);
  const location = useLocation();

  if (isAuthLoading) {
    // Do not redirect while authentication is still loading
    return null;
  }

  // 1. Check if user is authenticated
  if (!userInfo) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  // 2. Check for required roles (if any)
  if (allowedRoles.length > 0) {
    const hasPermission = userInfo.userRoles?.some(role => allowedRoles.includes(role));
    if (!hasPermission) {
      return <Navigate to={redirectTo} replace state={{ from: location }} />;
    }
  }

  return children;
};

export default PrivateRoute;
